// Metadados de status e ocorrências (pt-BR)
import { Scissors, Clock, AlertTriangle, PackageX } from "lucide-react";

export const STATUS = {
  SOLICITADO: { label: "Solicitado", cls: "text-slate-300 bg-slate-800/80 border-slate-600" },
  APROVADO: { label: "Aprovado", cls: "text-blue-300 bg-blue-950/80 border-blue-600" },
  EM_SEPARACAO: { label: "Em Separação", cls: "text-amber-300 bg-amber-950/80 border-amber-500" },
  SEPARADO: { label: "Separado", cls: "text-amber-200 bg-amber-900/60 border-amber-500" },
  EM_CONFERENCIA: { label: "Em Conferência", cls: "text-purple-300 bg-purple-950/80 border-purple-500" },
  CONFERIDO: { label: "Conferido", cls: "text-teal-300 bg-teal-950/80 border-teal-500" },
  EXPEDIDO: { label: "Expedido", cls: "text-blue-200 bg-blue-900/80 border-blue-500" },
  EM_TRANSITO: { label: "Em Trânsito", cls: "text-sky-300 bg-sky-950/80 border-sky-500" },
  RECEBIDO: { label: "Recebido", cls: "text-emerald-300 bg-emerald-950/80 border-emerald-500" },
  CONCLUIDO: { label: "Concluído", cls: "text-emerald-200 bg-emerald-900/90 border-emerald-400" },
  CANCELADO: { label: "Cancelado", cls: "text-red-300 bg-red-950/80 border-red-600" },
};

export const STATUS_ORDER = [
  "SOLICITADO", "APROVADO", "EM_SEPARACAO",
  "SEPARADO", "EM_CONFERENCIA", "CONFERIDO", "EXPEDIDO", "EM_TRANSITO", "RECEBIDO", "CONCLUIDO",
];

export const OCCURRENCE = {
  CORTE: { label: "Corte de Estoque", icon: Scissors, cls: "bg-red-500/20 text-red-300 border-red-500/50" },
  COMPLEMENTO_PENDENTE: { label: "Complemento Pendente", icon: Clock, cls: "bg-amber-500/20 text-amber-200 border-amber-500/50" },
  DIVERGENCIA: { label: "Divergência", icon: AlertTriangle, cls: "bg-purple-500/20 text-purple-200 border-purple-500/50" },
  AVARIA: { label: "Avaria", icon: PackageX, cls: "bg-rose-600/25 text-rose-200 border-rose-500/60" },
};

export const SITUACAO = {
  NORMAL: { label: "Normal", cls: "text-emerald-300 bg-emerald-950/70 border-emerald-600" },
  BAIXO: { label: "Baixo", cls: "text-amber-300 bg-amber-950/70 border-amber-600" },
  SEM_ESTOQUE: { label: "Sem Estoque", cls: "text-red-300 bg-red-950/70 border-red-600" },
};

export const DEV_STATUS = {
  SOLICITADA: { label: "Solicitada", cls: "text-slate-300 bg-slate-800/80 border-slate-600" },
  EM_ANALISE: { label: "Em análise", cls: "text-amber-300 bg-amber-950/80 border-amber-500" },
  EM_TRANSPORTE: { label: "Em Transporte", cls: "text-sky-300 bg-sky-950/80 border-sky-500" },
  RECEBIDA_CD: { label: "Recebida no CD", cls: "text-amber-300 bg-amber-950/80 border-amber-500" },
  CONFERIDA: { label: "Conferida", cls: "text-teal-300 bg-teal-950/80 border-teal-500" },
  FINALIZADA: { label: "Finalizada", cls: "text-emerald-300 bg-emerald-900/90 border-emerald-400" },
  CANCELADA: { label: "Cancelada", cls: "text-red-300 bg-red-950/80 border-red-600" },
};
export const DEV_ORDER = ["SOLICITADA", "EM_TRANSPORTE", "RECEBIDA_CD", "CONFERIDA", "FINALIZADA"];
export const DESTINOS = [
  { id: "RETORNO", label: "Retorno ao estoque" },
  { id: "BLOQUEIO", label: "Bloqueio" },
  { id: "DESCARTE", label: "Descarte" },
];

export const INV_STATUS = {
  ABERTO: { label: "Aberto", cls: "text-slate-300 bg-slate-800/80 border-slate-600" },
  EM_CONTAGEM: { label: "Em Contagem", cls: "text-amber-300 bg-amber-950/80 border-amber-500" },
  CONFERIDO: { label: "Conferido", cls: "text-teal-300 bg-teal-950/80 border-teal-500" },
  FINALIZADO: { label: "Finalizado", cls: "text-emerald-300 bg-emerald-900/90 border-emerald-400" },
  CANCELADO: { label: "Cancelado", cls: "text-red-300 bg-red-950/80 border-red-600" },
};
export const INV_ORDER = ["ABERTO", "EM_CONTAGEM", "CONFERIDO", "FINALIZADO"];
export const INV_TIPOS = [
  { id: "GERAL", label: "Geral" },
  { id: "CICLICO", label: "Cíclico" },
  { id: "UNIDADE", label: "Por Unidade" },
  { id: "CATEGORIA", label: "Por Categoria/Produto" },
];

export const ROLE_LABELS = {
  SUPER_ADMIN: "Administrador Geral",
  MASTER: "Master da Empresa",
  GESTOR: "Gestor",
  SUPERVISOR: "Supervisor",
  ESTOQUISTA: "CD/Estoquista",
  UNIDADE: "Recebimento/Unidade",
  TRANSPORTE: "Transporte/Motorista",
};

export const CARGA_STATUS = {
  AGUARDANDO_COLETA: { label: "Aguardando Coleta", cls: "text-slate-300 bg-slate-800/80 border-slate-600" },
  EM_EMBARQUE: { label: "Em Embarque", cls: "text-amber-300 bg-amber-950/80 border-amber-500" },
  EM_TRANSPORTE: { label: "Em Transporte", cls: "text-sky-300 bg-sky-950/80 border-sky-500" },
  CHEGADA: { label: "Chegada ao Destino", cls: "text-teal-300 bg-teal-950/80 border-teal-500" },
  EM_DESCARGA: { label: "Em Descarga", cls: "text-purple-300 bg-purple-950/80 border-purple-500" },
  ENTREGUE: { label: "Entregue", cls: "text-emerald-300 bg-emerald-900/90 border-emerald-400" },
  CANCELADA: { label: "Cancelada", cls: "text-red-300 bg-red-950/80 border-red-600" },
};
export const CARGA_ORDER = ["AGUARDANDO_COLETA", "EM_EMBARQUE", "EM_TRANSPORTE", "CHEGADA", "EM_DESCARGA", "ENTREGUE"];
export const OCORR_TRANSPORTE = [
  { id: "VOLUME_FALTANTE", label: "Volume faltante" },
  { id: "VOLUME_AVARIADO", label: "Volume avariado" },
  { id: "VOLUME_VIOLADO", label: "Volume violado" },
  { id: "VOLUME_ERRADO", label: "Volume errado" },
  { id: "TRANSPORTE_OUTRO", label: "Outra ocorrência" },
];

export const DEMO_ACCOUNTS = {};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const CATEGORIAS = ["Laticínios", "Congelados", "Secos", "Hortifrúti", "Embalagens"];

export const OC_STATUS = {
  ABERTA: { label: "Aberta", cls: "text-amber-300 bg-amber-950/70 border-amber-600" },
  EM_TRATAMENTO: { label: "Em Tratamento", cls: "text-sky-300 bg-sky-950/70 border-sky-600" },
  RESOLVIDA: { label: "Resolvida", cls: "text-emerald-300 bg-emerald-950/70 border-emerald-600" },
};
export const TRATAMENTO = {
  AGUARDANDO_DEVOLUCAO: { label: "Aguardando devolução", next: "EM_DEVOLUCAO", nextLabel: "Iniciar devolução" },
  EM_DEVOLUCAO: { label: "Em devolução", next: "RECEBIDO_CD", nextLabel: "Receber no CD (credita estoque)" },
  RECEBIDO_CD: { label: "Recebido no CD", next: "RESOLVIDO", nextLabel: "Marcar resolvido" },
  RESOLVIDO: { label: "Resolvido", next: null, nextLabel: null },
};
export const TRATAMENTO_ORDER = ["AGUARDANDO_DEVOLUCAO", "EM_DEVOLUCAO", "RECEBIDO_CD", "RESOLVIDO"];

export const AUDIT_LABELS = {
  // status
  SOLICITADO: "Solicitado", APROVADO: "Aprovado", EM_SEPARACAO: "Em separação",
  SEPARADO: "Separado", EM_CONFERENCIA: "Em conferência", CONFERIDO: "Conferido",
  EXPEDIDO: "Expedido", EM_TRANSITO: "Em trânsito", RECEBIDO: "Recebido",
  CONCLUIDO: "Concluído", CANCELADO: "Cancelado",
  // auditoria
  CRIAR_PEDIDO: "Pedido criado", APROVAR_PEDIDO: "Aprovação registrada",
  STATUS_EM_SEPARACAO: "Separação iniciada", STATUS_SEPARADO: "Separação finalizada",
  BIPAR_SEPARACAO: "Bipagem separação",
  BIPAR_CONFERENCIA: "Bipagem conferência", BIPAR_RECEBIMENTO: "Bipagem recebimento",
  EMBARCAR: "Embarque", CONFIRMAR_RECEBIMENTO: "Recebimento confirmado",
  REGISTRAR_DIVERGENCIA: "Divergência registrada",
  // estoque (ledger)
  RESERVA_SEPARACAO: "Reserva no CD", EXPEDICAO_CD: "Baixa expedição (CD)",
  RECEBIMENTO_TRANSITO: "Encerra trânsito", RECEBIMENTO_CREDITO: "Crédito na unidade",
  ESTORNO_RESERVA: "Estorno de reserva", ESTORNO_TRANSITO: "Estorno de trânsito",
  ESTORNO_EXPEDICAO: "Estorno de expedição", DEVOLUCAO_PRODUTO_ERRADO: "Retorno produto errado (CD)",
};

export const NAO_APROVACAO_FALLBACK = [
  "Quantidade acima da necessidade", "Item não autorizado", "Pedido duplicado",
  "Substituição/ajuste administrativo", "Outro",
];
export const CORTE_FALLBACK = [
  "Estoque insuficiente", "Divergência de estoque", "Produto avariado",
  "Produto vencido", "Produto não localizado", "Outro",
];

export const DIVERG_TIPOS = [
  { id: "FALTANTE", label: "Faltante" },
  { id: "EXCEDENTE", label: "Excedente" },
  { id: "PRODUTO_INCORRETO", label: "Produto incorreto" },
  { id: "AVARIA", label: "Avaria" },
  { id: "OUTRO", label: "Outro" },
];
